import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import "./App.css";

import Body from "./Pages/HomePage/Body";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import MostLikedPost from "./Pages/MostLikedPost/MostLikedPost";
import NavigationBar from "./components/NavBar/NavigationBar";
import Footer from "./components/Footer/Footer";
import AboutPage from "./Pages/AboutPage/AboutPage";
import BooksPage from "./Pages/BooksPage/Body";
import RecommendationsPage from "./Pages/Recommendations/RecommendationsPage";
import SignupConfirmPage from "./Pages/SignupConfirmPage/SignupConfirmPage";

// Local-only book admin. NODE_ENV is inlined at build time, so in production this
// is dead code and the admin page is left out of the bundle entirely.
const AdminPage =
  process.env.NODE_ENV === "development"
    ? require("./Pages/AdminPage/AdminPage").default
    : null;

function App() {
  return (
    <div className="App">
      <Router>
        <NavigationBar subscriptionUrl="https://substack.com/@quinnthomasauthor" />
        <div className="app-content">
          <Switch>
              <Route exact path="/" component={Body} />
              <Route exact path="/about" component={AboutPage} />
              <Route exact path="/books" component={BooksPage} />
              {AdminPage && <Route exact path="/admin" component={AdminPage} />}
              <Route
                exact
                path="/signUpConfirmation"
                component={SignupConfirmPage}
              />
              <Route
                exact
                path="/recommended"
                component={RecommendationsPage}
              />
              <Route exact path="/MostLikedPost" component={MostLikedPost} />
              <Route exact path="/:pageNo" component={Body} />
            </Switch>
        </div>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
